module.exports = __webpack_public_path__ + "static/alumigator-60476dae65976d5665b2fbbb1e7db5fc.jpg";